const ACCESS_TOKEN_KEY = "med_access_token";

export function getAccessToken() {
  try {
    return localStorage.getItem(ACCESS_TOKEN_KEY) || "";
  } catch (_) {
    return "";
  }
}

export function setAccessToken(token) {
  try {
    if (token) localStorage.setItem(ACCESS_TOKEN_KEY, token);
    else localStorage.removeItem(ACCESS_TOKEN_KEY);
  } catch (_) {}
}

export function clearAccessToken() {
  setAccessToken("");
}

export function hasAccessToken() {
  return Boolean(getAccessToken());
}
